/** @jsxImportSource @emotion/react */
import Root from "pages/root";
import {
  Container,
  ContentContainer,
  HeaderContainer,
  FilterContainer,
  FilterGroup,
  FilterTitleContainer,
  TileContainer,
  TileGroup,
  ChartTileContainer,
} from "./index.styles";
import UI from "@mile-meeting/mile-ui";
import { useEffect, useState } from "react";
import DashboardTile from "../../component/dashboard-tile";
import MonthPicker from "../../component/month-picker";
import WalkinVisitTypeCountPieChart from "./chart/walkin-visit-type-count-pie-chart";
import DailyVisitorCountBarChart from "./chart/daily-visitor-count-bar-chart";
import { getVisitorsMonthlyOverviewData } from "apis/analytics/visitors/dashboard";
import { TVisitorsOverviewDashBoard } from "types/analytics.types";

const VisitorsDashboard = () => {
  const [selectedDate, setSelectedDate] = useState<Date>(new Date());
  const [overviewData, setOverviewData] = useState<TVisitorsOverviewDashBoard | null>(null);

  const onChangeDate = (date: Date) => {
    setSelectedDate(date);
  };

  const getMeetingOverviewData = async (date: Date) => {
    const res = await getVisitorsMonthlyOverviewData({
      start: date.toString(),
      end: date.toString(),
    });
    if (res.success) {
      setOverviewData(res.data ?? null);
    }
  };

  useEffect(() => {
    getMeetingOverviewData(selectedDate);
  }, [selectedDate]);

  return (
    <Container>
      <HeaderContainer>
        <UI.Typography
          type="title03"
          fontStyle="bold"
          color="var(--alias-color-label-neutral)"
          style={{ padding: "24px 20px" }}
        >
          방문자 현황 대시보드
        </UI.Typography>
        <FilterContainer>
          <FilterGroup>
            <FilterTitleContainer>
              <UI.Typography type="body01 normal" fontStyle="medium" color="var(--alias-color-label-normal)">
                월별 조회
              </UI.Typography>
            </FilterTitleContainer>
            <MonthPicker selectedDate={selectedDate} onChangeDate={onChangeDate} />
          </FilterGroup>
        </FilterContainer>
      </HeaderContainer>
      <ContentContainer>
        <TileContainer>
          <TileGroup>
            <DashboardTile
              title="총 방문자 수"
              explain={`${selectedDate.getMonth() + 1}월의 총 방문자 수입니다.`}
              mainValue={(overviewData?.totalVisitorCount ?? 0).toLocaleString() + "명"}
            />
            <DashboardTile
              title="사전등록 방문자 수"
              explain={`${selectedDate.getMonth() + 1}월에 사전 등록 후 방문했던 방문자 수입니다.`}
              mainValue={(overviewData?.scheduledVisitorCount ?? 0).toLocaleString() + "명"}
            />
            <DashboardTile
              title="당일 방문자 수"
              explain={`${selectedDate.getMonth() + 1}월에 당일 방문했던 방문자 수입니다.`}
              mainValue={(overviewData?.walkinVisitorCount ?? 0).toLocaleString() + "명"}
            />
          </TileGroup>
        </TileContainer>
        <ChartTileContainer>
          <WalkinVisitTypeCountPieChart
            month={selectedDate.getMonth() + 1}
            monthlyDailyVisitorTypes={overviewData?.monthlyDailyVisitorTypes}
          />
          <DailyVisitorCountBarChart
            month={selectedDate.getMonth() + 1}
            monthlyDailyVisitorCounts={overviewData?.monthlyDailyVisitorCounts}
          />
        </ChartTileContainer>
      </ContentContainer>
    </Container>
  );
};

export default VisitorsDashboard;
